// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"055096f2","379":"3a05e9bc","787":"19728118","892":"6166c16f"}[chunkId] + ".chunk.js";
};